import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { LuxonDateHelper } from "@/Common/Helpers/LuxonDateHelper";
import { Button } from "@/DesignSystem/Molecules/Button";

import styles from "./AIScribe.module.scss";

interface IAIScribeDeletedPopupProps {
    deletedBy: string;
    deletionDateUTC: Date;
    onCreateNewNoteClicked: () => void;
}

function AIScribeMedicalNoteDeletedPopup(props: Readonly<IAIScribeDeletedPopupProps>): JSX.Element {
    const { getText } = useTranslation();
    const deletedDate = LuxonDateHelper.formatToFullDateTime(cacheStore.Helper.CreateDateAsUTC(props?.deletionDateUTC)) ?? "";

    function handleCreateNewNoteClicked(): void {
        props.onCreateNewNoteClicked();
    }

    function getEmployeeNameWithSuffix(): string {
        const employee = cacheStore.GetEmployeeByUserId(String(props.deletedBy));
        const employeeInfo = cacheStore.GetCliniciansPersonsByContactFacetId(employee.ContactFacet_id);

        return `${employeeInfo?.prefix ?? ""} ${employeeInfo?.FirstName ?? ""} ${employeeInfo?.LastName ?? ""}`;
    }

    function renderFooter(): JSX.Element {
        return (
            <div className="flex-container flex-end">
                <ButtonGroup>
                    <Button
                        category="primary"
                        variant="brand"
                        label={getText("AIScribe_CreateNewNote")}
                        onClick={handleCreateNewNoteClicked}
                        id="ai-scribe-create-new-note"
                        dataCy="ai-scribe-create-new-note"
                    />
                </ButtonGroup>
            </div>
        );
    }

    return (
        <Modal
            fixedOverlayPosition
            showOverlay
            roundTopCorner
            draggable
            disableOverlayClose
            width={465}
            title={getText("AIScribe_DeletedNoteWarning_Title")}
            id="ai-scribe-medical-note-deleted-popup"
            dataCy="ai-scribe-medical-note-deleted-popup"
            footer={renderFooter()}
            cssClass={styles.subscriptionExpiredPopup}
        >
            <div className={styles.body}>
                <p className={styles.firstSentence}>{`${getText("AIScribe_DeletedNoteWarning_Message1")} ${getEmployeeNameWithSuffix()}. (${deletedDate})`}</p>
                <p className={styles.secondSentence}>{getText("AIScribe_DeletedNoteWarning_Message2")}</p>
            </div>
        </Modal>
    );
}

export { AIScribeMedicalNoteDeletedPopup };
